var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.loading ? [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("store_scan_page.form_title") || "請掃描或輸入店家代碼") + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('store_scan_page.form_desc') || '請掃描店家 QR Code 或手動輸入店家代碼')
    }
  }), _c('div', {
    staticClass: "card pt-2 px-2"
  }, [_c('div', {
    staticClass: "card__info"
  }, [_c('div', [_c('coupon-filters', {
    staticClass: "s-mb-3",
    attrs: {
      "options": _vm.filterOptions
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading && _vm.filter == 'qrcode' ? _c('div', {
    staticClass: "qrcode-panel"
  }, [_c('QRCodeScanner', {
    attrs: {
      "qrbox": _vm.qrbox
    },
    on: {
      "onScan": _vm.onScan
    }
  })], 1) : !_vm.showLoading && _vm.filter == 'manual' ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.barcode,
      expression: "barcode"
    }],
    staticClass: "search__input m-auto w-100",
    attrs: {
      "placeholder": "請輸入店家代碼"
    },
    domProps: {
      "value": _vm.barcode
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.barcode = $event.target.value;
      }, _vm.barcodeFormatter]
    }
  })]) : _vm._e()], 1)], 1), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading ? _c('div', [_c('div', {
    staticClass: "p-4 rounded picker-content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('store_scan_page.content'))
    }
  })]) : _vm._e()], 1)])]), _c('div', {
    staticClass: "p-3 fixed-bottom bg-white footer"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2",
    attrs: {
      "disabled": !_vm.barcode || _vm.showLoading
    },
    on: {
      "click": _vm.confirmStore
    }
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("store_scan_page.button_text") || "確認店家") + " ")]), _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.getModuleConfig('store_scan_page.cancel_button_text') || '取消',
      "button-url": _vm.getModuleConfig('store_scan_page.cancel_button_url'),
      "type": _vm.getModuleConfig('store_scan_page.cancel_button_action') || 'back',
      "disabled": _vm.showLoading
    }
  })], 1)] : [_c('div', {
    staticClass: "text-center p-4"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary"
    }
  }), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("載入中...")])], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }